import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { COMMITMENTS } from "@/data/campaign";

const SITE = "https://aminnanji.ca";
const OG_IMAGE = `${SITE}/images/campaign-flyer.webp`;
const DEFAULT_TITLE = "Amin Nanji for Ward 11 Councillor | Mississauga 2026";
const DEFAULT_DESC =
  "Amin Nanji is a candidate for Mississauga City Councillor in Ward 11 (Streetsville, Meadowvale Village). Meet the candidate, priorities, and how to get involved.";

const SEO_MAP = {
  "/": [DEFAULT_TITLE, DEFAULT_DESC],
  "/about": [
    "About Amin Nanji — Ward 11 Candidate, Mississauga",
    "35+ years in Mississauga, 30+ in Ward 11. Engineer, local business owner, and lifelong volunteer. Meet Amin Nanji, candidate for Ward 11 City Councillor.",
  ],
  "/commitments": [
    "My Commitments to Ward 11 — Amin Nanji",
    "Six practical commitments for Ward 11: real neighbourhood voices, responsible growth, safer streets, respect for taxpayers, proven solutions, accountable representation.",
  ],
  "/ward11": [
    "Ward 11 Neighbourhoods — Streetsville, Meadowvale Village, Levi Creek, Credit Mills",
    "Ward 11 Mississauga is home to Streetsville, Meadowvale Village, Levi Creek, Credit Mills and more. Distinct communities, one shared voice.",
  ],
  "/get-involved": [
    "Get Involved — Volunteer, Lawn Signs & Updates | Amin Nanji for Ward 11",
    "Join the effort: volunteer, request a lawn sign, get campaign updates, or share the issue that matters most on your street in Ward 11.",
  ],
  "/contact": [
    "Contact Amin Nanji — Ward 11 Candidate, Mississauga",
    "Have a question, concern, or idea for Ward 11? Reach Amin Nanji directly by phone, email, or message.",
  ],
  "/donate": [
    "Donate — Amin Nanji for Ward 11",
    "Fuel the campaign for Ward 11. Secure online contributions in Canadian dollars. Maximum $1,200 per person under Ontario municipal election rules.",
  ],
  "/news": [
    "Ward 11 in the News — Mississauga Local Stories & Campaign Updates",
    "Latest local stories about Streetsville, Meadowvale Village, Levi Creek, Credit Mills, Erin Mills, and Mississauga Ward 11 — plus updates from the Amin Nanji campaign.",
  ],
  "/questions": [
    "Questions Residents Are Asking — Amin Nanji for Ward 11",
    "Answers to the questions neighbours across Ward 11 are asking — taxes, traffic, housing, development, voting, and community issues.",
  ],
  "/privacy": [
    "Privacy Policy — Amin Nanji for Ward 11",
    "How the Amin Nanji for Ward 11 campaign collects, uses, stores, and protects your personal information — including Ontario municipal election contribution rules.",
  ],
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const RouteSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let title = DEFAULT_TITLE;
    let desc = DEFAULT_DESC;
    let noindex = false;

    if (pathname.startsWith("/commitments/")) {
      const c = COMMITMENTS.find((x) => x.slug === pathname.split("/")[2]);
      if (c) {
        title = `${c.title} — Amin Nanji for Ward 11`;
        desc = c.short;
      }
    } else if (pathname.startsWith("/news/campaign/")) {
      title = "Campaign Update — Amin Nanji for Ward 11";
      desc = "News from the Amin Nanji for Ward 11 campaign, posted by our team.";
    } else if (pathname === "/admin" || pathname === "/campaign-hq") {
      title = "Campaign Hub — Sign In";
      desc = "Campaign administration.";
      noindex = true;
    } else if (SEO_MAP[pathname]) {
      [title, desc] = SEO_MAP[pathname];
    }

    document.title = title;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", SITE + pathname);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("name", "twitter:card", "summary_large_image");
    setCanonical(SITE + pathname);
  }, [pathname]);

  return null;
};

export default RouteSeo;
